import { useAuth } from "@clerk/react";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { ApiClient, UnauthorizedError } from "../lib/api";

export function useNotifications() {
	const { getToken, signOut } = useAuth();
	const client = new ApiClient(getToken);

	const query = useQuery({
		queryKey: ["notifications"],
		queryFn: () => client.getNotifications(),
		refetchInterval: 30_000,
		retry: (failureCount, error) => {
			if (error instanceof UnauthorizedError) return false;
			return failureCount < 3;
		},
	});

	useEffect(() => {
		if (query.error instanceof UnauthorizedError) {
			void signOut();
		}
	}, [query.error, signOut]);

	return query;
}

export function useMarkNotificationRead() {
	const { getToken } = useAuth();
	const client = new ApiClient(getToken);
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: string) => client.markNotificationRead(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["notifications"] });
		},
	});
}

export function useMarkAllNotificationsRead() {
	const { getToken } = useAuth();
	const client = new ApiClient(getToken);
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: () => client.markAllNotificationsRead(),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["notifications"] });
		},
	});
}
